import {takeEvery} from 'redux-saga/effects'

import {
  ADD_ITEM,
  DELETE_ITEMS_IN_BULK,
  DELETE_ITEM_BY_ID,
  GET_ITEM_BY_ID,
  GET_ITEM_LIST,
  UPDATE_ITEM,
} from '../../../Actions/ItemCategory/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ITEM_LIST, fetchData)
  yield takeEvery(DELETE_ITEM_BY_ID, fetchData)
  yield takeEvery(GET_ITEM_BY_ID, fetchData)
  yield takeEvery(UPDATE_ITEM, fetchData)
  yield takeEvery(ADD_ITEM, fetchData)
  yield takeEvery(DELETE_ITEMS_IN_BULK, fetchData)
}

export default dataSaga
